<template>
  <div>
    <div class="hcenter">
      <i style="margin-bottom: 10px" @click="back" class="el-icon-arrow-left"></i>
      <div style="width: 200px; margin-bottom: 10px; margin-right: 10px">
        <el-input :value="$route.query.pickingBatchBizNo" disabled />
      </div>
      <SearchComponent
        :selectOrInputList="selectOrInputList"
        @on-search="handleSearch"
        @on-reset="handleReset"
        :authIdentity="authIdentity"
      ></SearchComponent>
    </div>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      summary
      :summary-method="summaryMethod"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
      :cell-style="cellStyle"
    >
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="toDetail(scope.data, scope.$index)"
          >详情</el-button
        >
        <el-button
          class="button"
          v-hasPermi="[authIdentity + ':print']"
          @click="handlePrint(scope.data, scope.$index)"
          type="text"
          size="small"
          >打印</el-button
        >
        <!-- <el-dropdown style="margin-left:10px">
            <i class="el-icon-more"></i>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(dropdown, index) in operateMore"
                :disabled="fundisabled(dropdown, scope.data)"
                @click.native="dropdown.click(scope.data)"
                :key="index"
                :icon="'el-icon-ht-'+dropdown.auth"
              >{{ dropdown.label }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>-->
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="title"
      :visible.sync="dialogVisible"
      width="60%"
      :close-on-click-modal="false"
      :append-to-body="true"
      @closes="cancel"
    >
      <component ref="myform" :is="currentView"></component>
    </Mdialog>

    <el-dialog
      title="打印预览"
      class="dialog"
      :visible.sync="printInfo.printDialog"
      :close-on-click-modal="false"
      width="60%"
      @close="printInfo.printDialog = false"
      destroy-on-close
      append-to-body
      :top="'5vh'"
    >
      <PrintBox ref="printBox" v-if="printInfo.printDialog" />
    </el-dialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import PrintBox from '@/components/PrintBox'
import TablePublic from '@/components/tablePublic'
import myform from '@/views/procure/plan/components/form'

import { getInspectionSheetItemList } from '@/api/manage/inspection-sheet-item'
import { getFairValue } from '@/api/manage/universal-fair-value'

import { isDef } from '@/utils/is'
const STATUS_LIST = [
  { label: '达标', value: 1 },
  { label: '不达标', value: 2 },
]
export default {
  name: 'Receipt',
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    myform,
    PrintBox,
  },
  data() {
    const _this = this
    return {
      authIdentity: 'pick:warehouse',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'status',
          label: '验收结果',
          isTrue: true,
          formatter(row) {
            return STATUS_LIST.find((item) => item.value === row.status)?.label
          },
        },
        {
          prop: '',
          label: '果园过磅',
          isTrue: true,
          children: [
            {
              prop: 'totalQuantity',
              label: '满筐总筐数',
              isTrue: true,
              width: '100',
            },

            {
              prop: 'totalNetWeight',
              label: '总净重(斤)',
              isTrue: true,
              width: '100',
            },
          ],
        },
        {
          prop: '',
          label: '工厂核验',
          isTrue: true,
          children: [
            {
              prop: 'totalApprovedQuantity',
              label: '满筐总筐数',
              isTrue: true,
              width: '100',
            },
            {
              prop: 'totalApprovedNetWeight',
              label: '总净重(斤)',
              isTrue: true,
              width: '100',
            },
          ],
        },
        {
          prop: '',
          label: '不达标',
          isTrue: true,
          children: [
            {
              prop: 'notStandardNetWeight',
              label: '总净重(斤)',
              isTrue: true,
              width: '100',
              formatter(row) {
                return row.notStandardNetWeight || '-'
              },
            },
          ],
        },
        {
          prop: '',
          label: '结算数量',
          isTrue: true,
          children: [
            {
              prop: 'totalSettlementNetWeight',
              label: '总净重(斤)',
              isTrue: true,
              width: '100',
            },
          ],
        },
        {
          prop: 'operatorName',
          label: '验收人员',
          isTrue: true,
        },
        {
          prop: 'licensePlateNumber',
          label: '运输车牌号',
          isTrue: true,
        },
        {
          prop: 'lockNumber',
          label: '运输锁号',
          isTrue: true,
          width: '100',
        },
        {
          prop: 'freightDateTime',
          label: '运输时间',
          isTrue: true,
          width: '100',
          formatter(row) {
            return _this.parseTime(row.freightDateTime, '{y}-{m}-{d} {h}:{i}')
          },
        },

        {
          prop: 'inspectionDateTime',
          label: '验收时间',
          isTrue: true,
          width: '90',
          formatter(row) {
            return _this.parseTime(row.inspectionDateTime, '{y}-{m}-{d} {h}:{i}')
          },
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'status',
          placeholder: '请选择验收状态',
          value: 'value',
          label: 'label',
          list: STATUS_LIST,
          type: 'select',
        },
      ],

      printInfo: {
        printDialog: false,
        type: 'receipt',
        list: [],
      },

      fairValue: {},
    }
  },
  async mounted() {
    await this.getFairValue()
    this.getList()
  },
  methods: {
    async getFairValue() {
      const data = await getFairValue({ name: '验收差值' })

      if (data.code === 200) {
        const { maxFairValue, minFairValue } = data.data || {}
        this.fairValue = {
          maxFairValue,
          minFairValue,
        }
      }
    },
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getInspectionSheetItemList({ ...this.queryParams, pickingBatchId: this.$route.query.pickingBatchId })
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              // item.visible = false
              // item.locName = this.formatLocal(item.locDetails, 3)
              // item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              // item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              // item.readyForHarvest = CONSTANTS.getStatusConversion(item.readyForHarvestStatus, 'readyForHarvestStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error)
        })
    },
    summaryMethod(param) {
      const { columns, data } = param
      const sums = []

      // this.settleAmountPayAmount = 0
      columns.forEach((column, index) => {
        if (index == 1) {
          sums[index] = '合计'
          return
        }

        if (index == 2) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalQuantity || 0), 2)
          }, 0)
          return
        }
        if (index == 3) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalNetWeight || 0), 2)
          }, 0)
          return
        }
        if (index == 4) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalApprovedQuantity || 0), 2)
          }, 0)
          return
        }
        if (index == 5) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalApprovedNetWeight || 0), 2)
          }, 0)
          return
        }

        if (index == 6) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.notStandardNetWeight || 0), 2)
          }, 0) || '-'
          return
        }

        if (index == 7) {
          sums[index] = data.reduce((prev, cur) => {
            return this.myFixed(prev + (cur.totalSettlementNetWeight || 0), 2)
          }, 0)
          return
        }
      })
      return sums //返回sums数组,sums数组中各项就会显示在合计行的各列中
    },
    cellStyle({ row, column, rowIndex, columnIndex }) {
      const { maxFairValue, minFairValue } = this.fairValue

      const weightRate = this.myFixed((row.totalVarianceNetWeight / row.totalNetWeight) * 100, 2)

      if (row.status !== 1 && [1, 2, 3, 4, 5, 6, 7].includes(columnIndex)) {
        return {
          background: '#feeaea',
          color: 'red',
        }
      } else if (
        row.status === 1 &&
        isDef(maxFairValue) &&
        isDef(minFairValue) &&
        (weightRate > maxFairValue || weightRate < minFairValue) &&
        [2, 3, 4, 5, 6, 7].includes(columnIndex)
      ) {
        return {
          background: '#feeaea',
          color: 'red',
        }
      }
    },
    back() {
      this.$router.push({ path: '/warehouse' })
    },
    toDetail(row) {
      this.$router.push(`/warehouseDetail?id=${row.id}&inspectionSheetId=${row.inspectionSheetId}`)
    },
    handlePrint(row) {
      row.showShippingOrderBizNo = true
      
      this.printInfo.list = [row]

      this.printInfo.printDialog = true
      this.$nextTick(() => {
        this.$refs.printBox.init(this.printInfo)
      })
    },
    cancel() {
      this.dialogVisible = false
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '新增采购计划'
        this.currentView = 'myform'
        this.type = 'add'
      })
    },
    handleSearch(query) {
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
// @import '../../../../assets/form.less';
@import '~@/assets/variables.less';
.el-icon-arrow-left {
  font-size: 30px;
  color: @theme-color;
  cursor: pointer;
}

.hcenter {
  display: flex;
  align-items: center;
}
</style>
